import { apiClient } from '@/lib/axios';
import { ScansEnvelopeSchema } from '@/features/scans/types';
// Fetch one page of the all-scans view. `limit` and `page` are always sent.
// `userId` is optional: the all-scans admin view omits it (every user's scans),
// while the per-user journey passes it to scope the page to a single user.
export async function fetchScans({ page, limit, userId, }) {
    const response = await apiClient.get('/api/v1/scans/all', {
        // Send `userId` only when present so the all-scans call is byte-for-byte
        // unchanged. Whether the server honors it is verified by the caller; the
        // journey hook also filters client-side as a safety net.
        params: userId ? { limit, page, userId } : { limit, page },
    });
    // This API uses HTTP 200 for errors too, flagging them in the envelope. Auth
    // failures are handled centrally by the axios interceptor; surface any other
    // server-reported failure as a clean error for the page's error state.
    const data = response.data;
    if (data && typeof data === 'object' && data.success === false) {
        const message = data.message;
        throw new Error(typeof message === 'string' && message.length > 0 ? message : 'Failed to load scans.');
    }
    return ScansEnvelopeSchema.parse(data);
}
